import * as React from 'react'
import uniqueId from 'lodash/uniqueId'

export const useId = (prefix = 'id-') => {
  const [id] = React.useState(uniqueId(prefix))

  return id
}
